import moment from 'moment';
import BaseServiceRead from './BaseServiceRead';

export default class InvoiceService extends BaseServiceRead {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'invoice';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            date_from: criteria.dateFrom ? moment(criteria.dateFrom).format('YYYY-MM-DD') : undefined,
            date_to: criteria.dateTo ? moment(criteria.dateTo).format('YYYY-MM-DD') : undefined,
            amount_from: criteria.amountFrom ? criteria.amountFrom : undefined,
            amount_to: criteria.amountTo ? criteria.amountTo : undefined,
            invoice_number: criteria.invoiceNumber,
            status: criteria.status?.enumValue,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    getLastInvoice() {
        return this.fetch(`${this.domain}/${this.path}/last-invoice`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getUnpaidList() {
        return this.fetch(`${this.domain}/${this.path}/unpaid-list`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    p24PaymentToken(requestBody) {
        return this.fetch(`${this.domain}/${this.path}/p24PaymentToken`, {
            method: 'POST',
            body: JSON.stringify(requestBody),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    acceptOng(invoiceNumber, acceptOng) {
        return this.fetch(`${this.domain}/${this.path}/accept-ong`, {
            method: 'PUT',
            body: JSON.stringify({invoiceNumber, acceptOng}),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    downloadInvoicePdf(petraFileId, invoiceNumber, invoiceDate) {
        return this.fetch(
            `${this.domain}/${this.path}/download-pdf`,
            {
                method: 'POST',
                body: JSON.stringify({petraFileId, invoiceNumber, invoiceDate}),
            },
            {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cache',
            }
        ).then((res) => {
            return Promise.resolve(res);
        });
    }

    acceptOngPublic(invoiceNumber, password, acceptOng) {
        return this.fetch(`${this.domain}/${this.path}/public-accept-ong`, {
            method: 'PUT',
            body: JSON.stringify({invoiceNumber, password, acceptOng}),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    downloadInvoicePdfPublic(petraFileId, invoiceNumber, password) {
        return this.fetch(
            `${this.domain}/${this.path}/public-download-pdf`,
            {
                method: 'POST',
                body: JSON.stringify({petraFileId, invoiceNumber, password}),
            },
            {
                Accept: 'application/octet-stream',
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cahce',
            }
        ).then((res) => {
            return Promise.resolve(res);
        });
    }

    getFleetStatementPublic(flsNumber, password) {
        return this.fetch(`${this.domain}/${this.path}/public-fls`, {
            method: 'POST',
            body: JSON.stringify({flsNumber, password}),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    fleetStatementActionPublic(cbkId, flsNumber, ipAddress, actionType, rejectionCode, rejectionText) {
        return this.fetch(`${this.domain}/${this.path}/public-fls-action`, {
            method: 'PUT',
            body: JSON.stringify({cbkId, flsNumber, ipAddress, actionType, rejectionCode, rejectionText}),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }


    countPragmaCosts(val, days) {

        return this.fetch(`${this.domain}/${this.path}/pragmaCosts/${val}/${days}`, {
            method: 'GET',
        }).then((res) => {

            return Promise.resolve(res);
        });
    }

/*     generatePragmaRequestData(invoiceId) {
        return this.fetch(`${this.domain}/${this.path}/pragma-form/${invoiceId}`, {
            method: 'GET',
        }).then((res) => {

            return Promise.resolve(res);
        });
    }
 */
    generatePragmaRequestData(invoiceNumber, defermentDays) {
        return this.fetch(`${this.domain}/${this.path}/pragma-form/${invoiceNumber}`, {
            method: 'POST',
           // body: JSON.stringify({defermentDays}),
            body: defermentDays ,
        }).then((res) => {
            return Promise.resolve(res);
        })
        .catch((err) => {
            throw err;
        });
    }


    downloadInvoiceAttachment(petraFileId, invoiceNumber, invoiceDate, format) {
        return this.fetch(
            `${this.domain}/${this.path}/download-attachment`,
            {
                method: 'POST',
                body: JSON.stringify({petraFileId, invoiceNumber, invoiceDate, format}),
            },
            {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cache',
            }
        ).then((res) => {
            return Promise.resolve(res);
        });
    }
}
